// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integrationMigrationPage {
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D1D5DB;
    border-radius: 10px;
    font-size: 15px;
}

.modelDIV {
    margin: 44px;
    justify-content: flex-start;
}

.contentOuterDIV {
    margin-top: 38px;
}

.contentInnerDIV {
    margin-top: 31px;
}

th {
    min-width: 100%;
    max-width: 100%;
    border-color: black;
}

.mig-table {
    margin-top: 5%;
    overflow: auto;
    width: 95%;
}

    .mig-table select {
        width: 100%;
        padding: 4px;
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
        appearance: none;
        cursor: pointer;
    }

    .mig-table th {
        padding: 4px;
        position: relative;
    }

.table-header {
    max-width: 100%;
}

input {
    width: 100%;
}

.connector {
    border-width: 1px 0px;
    border-color: #D1D5DB;
    border-style: dashed;
    width: 115px;
    height: 1px;
    align-self: center;
}

.colWidth {
    width: 217px;
    margin-top: 6px;
    margin-bottom: 6px;
    background: white;
}

.sourceCol {
    padding: 0px 40px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
}

    .sourceCol > span {
        text-overflow: ellipsis;
        overflow: hidden;
        font: normal normal 500 15px/20px Segoe UI;
        white-space: nowrap;
    }

.targetCol {
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
}

.colHeaderRight, .colHeaderLeft {
    background: var(--integration-background);
    color: var(--integration-text);
    padding: 0px 40px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    width: 217px;
    height: 39px;
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
}


/*box-shadow: 0px 3px 6px #00000029;
border-radius: 6px;
margin-top: 44px;
margin-bottom: 4px;
align-items: center;
justify-content: center;
width: 217px;
height: 39px;
font: normal normal 600 15px/20px Segoe UI;
opacity: 1;
*/
.colHeaderRight {
    margin-left: 115px;
}

.migrationLine {
    height: 56px;
    border-radius: 6px;
    margin-bottom: 6px;
    align-self: flex-start;
    padding-right: 22px;
}

    .migrationLine.lineSelected {
        background: #ebebebbf 0% 0% no-repeat padding-box;
    }

.migLineCheck {
    margin: 0px 22px;
}

.migrationCombobox {
    width: 216px;
    height: 37px;
}

.migrationTextbox {
    width: 216px;
    height: 37px;
}

.fileName {
    background-color: #ebebeb;
    margin-bottom: 31px;
    border-radius: 4px;
}
.fileNameText {
    padding: 4px;
    font: normal normal 600 15px/20px Segoe UI;
    color: #454545;
}

.comboboxHeader {
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
    color: #374151;
    margin-bottom: 4px;
}

.createNewTableButton {
    justify-content: flex-start;
    align-items: center;
    padding: 4px;
    font: normal normal 600 17px/22px Segoe UI;
    color: var(--integration-text-color);
    cursor: pointer;
    margin-top: 4px;
}

.addIcon {
    height: 20px;
    width: 20px;
    margin-right: 4px;
    color: var(--integration-background-color);
}

.existingDataHeader {
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
    color: #374151;
    margin-top: 2px;
    /*margin-bottom: 4px;*/
}
.existingDataSubHeader {
    margin-top: 2px;
    font: normal normal 600 15px/20px Segoe UI;
    color: var(--integration-light-text-color);
    opacity: 1;
}

.migRadioBtn {
    margin-top: 8px;
    margin-left: 10px;
    color: var(--integration-color);
}`, "",{"version":3,"sources":["webpack://./src/app/integration/integrationwizard/iw.migration.page.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;AACd;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;QAGb,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;AACtB;;IAEI;QACI,uBAAuB;QACvB,gBAAgB;QAChB,0CAA0C;QAC1C,mBAAmB;IACvB;;AAEJ;IACI,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,iBAAiB;IACjB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,0CAA0C;IAC1C,UAAU;AACd;;;AAGA;;;;;;;;;;CAUC;AACD;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;IAEI;QACI,iDAAiD;IACrD;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;IAC1C,oCAAoC;IACpC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC","sourcesContent":[".integrationMigrationPage {\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #D1D5DB;\n    border-radius: 10px;\n    font-size: 15px;\n}\n\n.modelDIV {\n    margin: 44px;\n    justify-content: flex-start;\n}\n\n.contentOuterDIV {\n    margin-top: 38px;\n}\n\n.contentInnerDIV {\n    margin-top: 31px;\n}\n\nth {\n    min-width: 100%;\n    max-width: 100%;\n    border-color: black;\n}\n\n.mig-table {\n    margin-top: 5%;\n    overflow: auto;\n    width: 95%;\n}\n\n    .mig-table select {\n        width: 100%;\n        padding: 4px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        outline: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        cursor: pointer;\n    }\n\n    .mig-table th {\n        padding: 4px;\n        position: relative;\n    }\n\n.table-header {\n    max-width: 100%;\n}\n\ninput {\n    width: 100%;\n}\n\n.connector {\n    border-width: 1px 0px;\n    border-color: #D1D5DB;\n    border-style: dashed;\n    width: 115px;\n    height: 1px;\n    align-self: center;\n}\n\n.colWidth {\n    width: 217px;\n    margin-top: 6px;\n    margin-bottom: 6px;\n    background: white;\n}\n\n.sourceCol {\n    padding: 0px 40px;\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #D1D5DB;\n    border-radius: 6px;\n}\n\n    .sourceCol > span {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        font: normal normal 500 15px/20px Segoe UI;\n        white-space: nowrap;\n    }\n\n.targetCol {\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #D1D5DB;\n    border-radius: 6px;\n}\n\n.colHeaderRight, .colHeaderLeft {\n    background: var(--integration-background);\n    color: var(--integration-text);\n    padding: 0px 40px;\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px solid #D1D5DB;\n    border-radius: 6px;\n    align-items: center;\n    justify-content: center;\n    width: 217px;\n    height: 39px;\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n}\n\n\n/*box-shadow: 0px 3px 6px #00000029;\nborder-radius: 6px;\nmargin-top: 44px;\nmargin-bottom: 4px;\nalign-items: center;\njustify-content: center;\nwidth: 217px;\nheight: 39px;\nfont: normal normal 600 15px/20px Segoe UI;\nopacity: 1;\n*/\n.colHeaderRight {\n    margin-left: 115px;\n}\n\n.migrationLine {\n    height: 56px;\n    border-radius: 6px;\n    margin-bottom: 6px;\n    align-self: flex-start;\n    padding-right: 22px;\n}\n\n    .migrationLine.lineSelected {\n        background: #ebebebbf 0% 0% no-repeat padding-box;\n    }\n\n.migLineCheck {\n    margin: 0px 22px;\n}\n\n.migrationCombobox {\n    width: 216px;\n    height: 37px;\n}\n\n.migrationTextbox {\n    width: 216px;\n    height: 37px;\n}\n\n.fileName {\n    background-color: #ebebeb;\n    margin-bottom: 31px;\n    border-radius: 4px;\n}\n.fileNameText {\n    padding: 4px;\n    font: normal normal 600 15px/20px Segoe UI;\n    color: #454545;\n}\n\n.comboboxHeader {\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n    color: #374151;\n    margin-bottom: 4px;\n}\n\n.createNewTableButton {\n    justify-content: flex-start;\n    align-items: center;\n    padding: 4px;\n    font: normal normal 600 17px/22px Segoe UI;\n    color: var(--integration-text-color);\n    cursor: pointer;\n    margin-top: 4px;\n}\n\n.addIcon {\n    height: 20px;\n    width: 20px;\n    margin-right: 4px;\n    color: var(--integration-background-color);\n}\n\n.existingDataHeader {\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n    color: #374151;\n    margin-top: 2px;\n    /*margin-bottom: 4px;*/\n}\n.existingDataSubHeader {\n    margin-top: 2px;\n    font: normal normal 600 15px/20px Segoe UI;\n    color: var(--integration-light-text-color);\n    opacity: 1;\n}\n\n.migRadioBtn {\n    margin-top: 8px;\n    margin-left: 10px;\n    color: var(--integration-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
